import * as docx from 'docx';
import {Paragraph, TableCell, TableRow, WidthType} from 'docx';

const borders = {
  top: {
    style: docx.BorderStyle.DASH_SMALL_GAP,
    color: '#FFFFFF'
  },
  bottom: {
    style: docx.BorderStyle.DASH_SMALL_GAP,
    color: '#FFFFFF'
  },
  left: {
    style: docx.BorderStyle.DASH_SMALL_GAP,
    color: '#FFFFFF'
  },
  right: {
    style: docx.BorderStyle.DASH_SMALL_GAP,
    color: '#FFFFFF'
  },
};

const interlines: any = {'1': 240, '1.15': 276, '1.5': 360};

export const formatContractsValue = (contracts: string ) => {
  if(contracts === '') {
      return '-'
  }

  return contracts;
}

function stringDivder(str: string, numberWithoutSpaces = 25): string {
  let result = '';
  let counter = 0;
  str?.split('').forEach(ch => {
    if (ch === ' ') {
      counter = 0;
    }
    if (counter === numberWithoutSpaces) {
      result += ' ';
      counter = 0;
    }
    counter += 1;
    result += ch;
  });
  return result;
}

export function removeNonPrintableChars(text: string) {
  if (typeof text !== 'string') {
    return text;
  }
  return text.replace(/\x02/g, '');
}


export function brakeLine(size: number, noSpace?: boolean) {
  return (
    new docx.Paragraph({
      children: [
        new docx.TextRun({
          text: ' ',
          size: size,
          font: 'Calibri',
        }),
      ],
      alignment: docx.AlignmentType.CENTER,
      spacing: {
        after: noSpace ? 0 : size === 20 ? 90 : 240,
        line: size === 20 ? interlines['1'] : interlines['1.15'],
        lineRule: docx.LineRuleType.AUTO
      },
    })
  )
}

export function pageHeader(text: string) {
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: removeNonPrintableChars(text),
            size: 16,
            font: 'Arial',
            color: '#616161'
          }),
        ],
        alignment: docx.AlignmentType.CENTER,
      })
  )
}

export function header(text: string) {
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: removeNonPrintableChars(text),
            size: 36,
            font: 'Calibri',
            bold: true
          }),
        ],
        alignment: docx.AlignmentType.CENTER,
        spacing: {
          line: interlines['1'],
          lineRule: docx.LineRuleType.AUTO
        },
      })
  )
}

export function blockTitle(text: string) {
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: removeNonPrintableChars(text),
            size: 28,
            font: "Calibri",
            bold: true,
          }),
        ],
        spacing: {
          after: 150,
          line: interlines['1.15'],
          lineRule: docx.LineRuleType.AUTO
        },
      })
  )
}

export function subTitle(text: string, before?: number, after?: number) {
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: removeNonPrintableChars(text),
            size: 28,
            font: "Calibri",
            bold: true,
          }),
        ],
        spacing: {
          before: before ?? 350,
          after: after ?? 120,
          line: interlines['1.15'],
          lineRule: docx.LineRuleType.AUTO
        },
      })
  )
}

export function subTitle13(text: string, before?: number, after?: number) {
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: removeNonPrintableChars(text),
            size: 26,
            font: "Calibri",
            bold: true,
          }),
        ],
        spacing: {
          before: before ?? 150,
          after: after ?? 120,
          line: interlines['1.15'],
          lineRule: docx.LineRuleType.AUTO
        },
      })
  )
}

export function subTitleWithLines(text: string, correction: number = 0) {
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: `––– ${removeNonPrintableChars(text)} ${new Array(68 - text.length + correction).join('–')}`,
            size: 26,
            font: "Calibri",
            bold: true,
          }),
        ],
        spacing: {
          after: 200,
          line: interlines['1.15'],
          lineRule: docx.LineRuleType.AUTO
        },
      })
  )
}

export function detailRow(label: string, description: string) {
  return (
      new docx.TableRow({
        children: [
          new docx.TableCell({
            width: {
              size: 3505,
              type: docx.WidthType.DXA,
            },
            children: [detail(label, true)],
            borders,
          }),
          new docx.TableCell({
            children: [detail(description)],
            borders
          }),
        ],
      })
  )
}

function detail(text: string, bold = false) {
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: removeNonPrintableChars(text),
            size: 22,
            font: "Calibri",
            bold: bold,
          }),
        ],
        spacing: {
          after: 125,
          line: interlines['1'],
          lineRule: docx.LineRuleType.AUTO
        },
      })
  )
}

export function correctionTable<Data>(headers: string[], dataRow: Data[], rowTransformer: (args: Data) => TableRow) {
  let header: TableRow = tableRow(headers, true);
  let rows = dataRow.map(data => rowTransformer(data));
  return new docx.Table({
    rows: [header].concat(rows),
    layout: docx.TableLayoutType.FIXED,
    width: { size: 100, type: WidthType.PERCENTAGE },
    columnWidths: [510, 810, 1620, 910, 810, 810, 910, 910, 910, 910],
  });
}

export function ordersTable(rows: string[][], isControlListApproved = true) {
  if (isControlListApproved && rows?.length > 1) {
      return [
        new docx.Paragraph({
          children: [
            new docx.TextRun({
              text: ' ',
              size: 10,
              font: "Calibri",
            }),
          ],
          spacing: {line: 50, after: 50},
        }),
        new docx.Table({
            layout: docx.TableLayoutType.FIXED,
            width: { size: 100, type: WidthType.PERCENTAGE },
            columnWidths: [3033, 3033, 3033],
            rows: rows.map((row, i) => tableRow(row, i === 0))
        }),
        new docx.Paragraph({
          children: [
            new docx.TextRun({
              text: ' ',
              size: 20,
              font: "Calibri",
            }),
          ],
        }),
      ]
  }
  return [new docx.Paragraph({
    children: [
      new docx.TextRun({
        text: '',
        size: 0,
        font: "Calibri",
      }),
    ],
    spacing: {line: 0, after: 0},
  })];
}

export function tableRow(values: string[], isHeader?: boolean) {
  let cells: TableCell[] = values.map(it => new TableCell({
    children: [new Paragraph({
      children: [
        new docx.TextRun({
          text: removeNonPrintableChars(it) || '',
          size: 20,
          font: "Calibri",
          bold: isHeader,
        }),
      ],
      alignment: isHeader ? docx.AlignmentType.CENTER : undefined,
    })],
    verticalAlign: isHeader ? docx.VerticalAlign.CENTER : undefined,
    shading: isHeader ? {fill: "F2F2F2"} : undefined,
    margins: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
  },
  }));
  return new TableRow({
    children: cells,
  });
}

export function draft(controlListApproved: boolean) {
  if (controlListApproved) {
    return  new docx.Paragraph({
      children: [
        new docx.TextRun({}),
      ],
    });
  }
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: 'WERSJA ROBOCZA',
            size: 22,
            font: "Calibri",
            bold: true,
            color: '#d50000'
          }),
        ],
        spacing: {line: 276, after: 110},
      })
  )
}

export function textWarning(text: string, size?: number, bold?: boolean) {
  return (
      new docx.Paragraph({
        children: [
          new docx.TextRun({
            text: removeNonPrintableChars(text),
            size: size ? size : 22,
            font: "Calibri",
            bold: bold,
            color: '#FF0000'
          }),
        ],
        spacing: {line: 276, before: 150, after: 150},
      })
  )
}

export function text(text: string, size?: number, italics?: boolean, bold?: boolean, isBreak?: boolean, isUnderline?: boolean) {
  return (
      new docx.TextRun({
        text: removeNonPrintableChars(text),
        size: size || 22,
        font: "Calibri",
        bold: bold,
        break: isBreak ? 1 : undefined,
        italics: italics,
        underline: isUnderline ? {type: docx.UnderlineType.SINGLE} : undefined
      })
  )
}

export function textInParagraph(text: string) {
  return (
      new docx.Paragraph({
        children: [new docx.TextRun({
          text: removeNonPrintableChars(text),
          size: 22,
          font: "Calibri"
        })]
      })
  )
}

export function textInParagraphWithSpacing(text: string, italics?: boolean, bold?: boolean, isBreak?: boolean) {
  return (
    new docx.Paragraph({
      children: [new docx.TextRun({
        text: removeNonPrintableChars(text),
        size: 22,
        font: "Calibri",
        italics: italics ?? undefined,
        bold: bold ?? undefined,
        break: isBreak ? 1 : undefined
      })],
      spacing: {
        before: 350,
        after: 70,
        line: 276,
        lineRule: docx.LineRuleType.AUTO
      },
    })
  );
}

export function blockName(text: string, size?: number, italics?: boolean, bold?: boolean, isBreak?: boolean, isUnderline?: boolean) {
  return (
    new docx.Paragraph({
      children: [new docx.TextRun({
        text: removeNonPrintableChars(text),
        size: size || 22,
        font: "Calibri",
        bold: bold,
        break: isBreak ? 1 : undefined,
        italics: italics,
        underline: isUnderline ? {type: docx.UnderlineType.SINGLE} : undefined
      })],
      spacing: {
        before: 600,
        after: 150,
        line: 276,
        lineRule: docx.LineRuleType.AUTO
      },
    })
  );
}

export function answer(answer: string) {
  return (
    new docx.Paragraph({
      children: [
        new docx.TextRun({
          text: 'Odpowiedź: ',
          size: 22,
          font: "Calibri",
        }),
        new docx.TextRun({
          text: removeNonPrintableChars(answer),
          size: 22,
          font: "Calibri",
          bold: true
        }),
    ],
    spacing: {
      before: 100,
      after: 135,
      line: 276,
      lineRule: docx.LineRuleType.AUTO
    },
    })
  );
}

export function textAnswer(textAnswer: string, italics?: boolean) {
  return (
    new docx.Paragraph({
      children: [
        new docx.TextRun({
          text: removeNonPrintableChars(textAnswer),
          size: 22,
          font: "Calibri",
          italics: italics
        }),
    ],
    spacing: {
      before: 0,
      after: 0,
      line: 276,
      lineRule: docx.LineRuleType.AUTO
    },
    })
  );
}

export function label(label: string, italics?: boolean, before?: number) {
  return (
    new docx.Paragraph({
      children: [
        new docx.TextRun({
          text: removeNonPrintableChars(label),
          size: 22,
          font: "Calibri",
          bold: true,
          italics: italics
        }),
    ],
    spacing: {
      before: before ?? 0,
      after: 0,
      line: 276,
      lineRule: docx.LineRuleType.AUTO
    },
    })
  );
}

export function question(questionNumber: string, question: string) {
  return (
    new docx.Paragraph({
      children: [
        new docx.TextRun({
          text: `${questionNumber} `,
          size: 22,
          font: "Calibri",
          bold: true,
          break: 1
        }),
        new docx.TextRun({
          text: removeNonPrintableChars(question),
          size: 22,
          font: "Calibri"
        }),
    ],
    spacing: {
      before: 70,
      after: 70,
      line: 276,
      lineRule: docx.LineRuleType.AUTO
    },
    })
  );
}